module.exports = __webpack_public_path__ + "img/Dagger_dagger.d740ebf6.png";